var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import theme from '../../../theme';
import { getBorderColor } from '../utils';
import { DropdownValueBold } from './css';
export var generateDropdownStyles = function (_a) {
    var states = _a.states, menuPosition = _a.menuPosition;
    return ({
        option: function (provided, state) { return (__assign(__assign(__assign({}, provided), DropdownValueBold), { background: state.isSelected || state.isFocused ? theme.primaryColours.paleGray.main : theme.primaryColours.white.main, color: theme.primaryColours.aubergine.main, padding: '8px 16px', '&:hover': {
                background: theme.tints.paleGray,
                cursor: 'pointer',
            }, '&:active': {
                background: theme.primaryColours.paleGray.main,
            } })); },
        control: function (provided, state) { return ({
            width: '100%',
            display: 'inline-flex',
            borderRadius: '4px',
            border: "2px solid",
            borderColor: state.isFocused ? theme.primaryColours.aubergine.main : getBorderColor(states),
            cursor: 'pointer',
            background: theme.primaryColours.white.main,
            '&:hover': {
                background: states !== 'Validated' && states !== 'Errored'
                    ? theme.primaryColours.white.main
                    : states === 'Validated'
                        ? theme.tints.mint
                        : theme.tints.amber,
                borderColor: states !== 'Validated' && states !== 'Errored' ? theme.primaryColours.slateGray.main : getBorderColor(states),
            },
        }); },
        valueContainer: function (provided) { return (__assign(__assign({}, provided), { padding: '20px 0 20px 20px', color: theme.primaryColours.aubergine.main })); },
        dropdownIndicator: function () { return ({
            height: '16px',
            marginTop: '-2px',
            marginRight: '16px',
        }); },
        menu: function (provided) { return (__assign(__assign({}, provided), { width: '100%', borderRadius: '4px', border: "2px solid ".concat(theme.primaryColours.paleGray.main), boxShadow: theme.shadows.mainShadow, marginTop: '2px', position: menuPosition ? menuPosition : 'absolute' })); },
        singleValue: function () { return (__assign(__assign({}, DropdownValueBold), { fontWeight: 'bold', textOverflow: 'ellipsis', textWrap: 'nowrap', overflow: 'hidden' })); },
        placeholder: function () { return (__assign(__assign({}, DropdownValueBold), { fontWeight: 'bold', color: theme.primaryColours.slateGray.darkSlateGray })); },
    });
};
